<template>
    <a-input
        :disabled="disabled"
        :value="modelValue"
        :maxlength="maxLength"
        :placeholder="this.placeholder"
        :allowClear="this.allowClear"
        @input="updateValue"
    >
    </a-input>
</template>

<script>
export default {
    props: {
        modelValue: [String, Number],
        disabled: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            default: '',
        },
        allowClear: {
            type: Boolean,
            default: false,
        },
        maxLength: {
            type: Number,
            default: Infinity,
        },
        formatter: {
            type: Function,
            default: (value) => value,
        },
    },
    data() {
        return {
            setFormatting: true,
        };
    },
    methods: {
        updateValue(event) {
            let value = event.target.value;

            if (this.setFormatting) {
                value = this.formatter(value);
            }

            this.$emit('update:modelValue', value);
            this.$emit('updatedValue');
        },
    },
};
</script>
